import React from 'react';

interface AustraliaIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

const AustraliaIcon: React.FC<AustraliaIconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Simplified outline of Australia */}
      <path d="M 20 8 L 19 7 L 18 6.5 L 17 6 L 16 6 L 15 6.5 L 14.5 7 L 14 7.5 L 13.5 8 L 13 8.5 L 12.5 9 L 12 9 L 11.5 8.5 L 11 8 L 10.5 7.5 L 10 7.5 L 9.5 8 L 9 8.5 L 8.5 9 L 8 9.5 L 7.5 10 L 7 10.5 L 6.5 11 L 6 11.5 L 5.5 12 L 5 12.5 L 4.5 13 L 4 13.5 L 3.5 14 L 3.5 14.5 L 4 15 L 4.5 15.5 L 5 16 L 5.5 16.5 L 6 17 L 6.5 17.5 L 7 18 L 7.5 18.5 L 8 18.5 L 8.5 18.5 L 9 18.5 L 9.5 18.5 L 10 18.5 L 10.5 18.5 L 11 18.5 L 11.5 18.5 L 12 18.5 L 12.5 18.5 L 13 18.5 L 13.5 18.5 L 14 18.5 L 14.5 18.5 L 15 18.5 L 15.5 18.5 L 16 18.5 L 16.5 18 L 17 17.5 L 17.5 17 L 18 16.5 L 18.5 16 L 19 15.5 L 19.5 15 L 20 14.5 L 20.5 14 L 20.5 13.5 L 20.5 13 L 20.5 12.5 L 20.5 12 L 20.5 11.5 L 20.5 11 L 20.5 10.5 L 20.5 10 L 20.5 9.5 L 20.5 9 L 20.5 8.5 L 20 8 Z" />
      {/* Tasmania */}
      <path d="M 14 20 L 13.5 20.5 L 13.5 21 L 14 21.5 L 14.5 21.5 L 15 21 L 15 20.5 L 14.5 20 L 14 20 Z" />
    </svg>
  );
};

export default AustraliaIcon;